import axios from "axios";
import { baseUrl } from "../Pages/ApiCommonService";
import { expTokenProcessAndGenerate } from "./AuthApis";

const token = sessionStorage.getItem("token");

// -------------------****Api Calls Outside the RoleMasterTables (fetchRser, saveData, activateOrDeactivate)****-------------------------//

export const fetchRole = async () => {     // getApi to fetchUsers in the Usermaster screen
  try {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    const response = await axios.get(baseUrl + "api/master/listAllRoles", {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status === 200) {
      return response?.data;
    }
  } catch (error) {
    console.error("Error in fetching the role:", error);
    throw error;
  }
};

export const editRoleByRowSelection = async (id: string) => {       // getApi to edit the user on click of Edit icon
  try {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    const response = await axios.get(
      baseUrl + `api/master/getRoleById?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200) {
      return response?.data;
    }
  } catch (error) {
    console.error("Error in editing the selected role:", error);
    throw error;
  }
};

export const saveRole = async (selectedRow: any, editMode: boolean) => {       // saveApi if any selected RowItem is updated or new Role creation
  try {
    const isEdit = !!editMode;
    const payload = isEdit
      ? selectedRow
      : {
        RoleName: selectedRow.RoleName || "",
        IsActive: selectedRow.IsActive || false,
        CreatedOn: editMode
          ? selectedRow?.CreatedOn
          : new Date().toISOString(),
        UpdatedOn: new Date().toISOString(),
      };

    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    const response = await axios.post(
      baseUrl + "api/master/roles",
      payload,
      {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "application/json",
        },
      }
    );
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    console.error("Error creating_Or_updating role:", error);
    throw error;
  }
};

export const activateAndDeactivateRoles = async ( selectedRowIds: string[], status: boolean ) => {  // Api to active and deactive the selected role rowItem
  const requestData = {
    ids: selectedRowIds,
    status: status,
  };

  try {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    await axios.post(
      `${baseUrl}api/master/activate_Or_DeactivateRole?role_id=${requestData.ids[0]}&status=${requestData.status}`,
      requestData,
      {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (error) {
    console.error("Error updating role status:", error);
    throw error;
  }
};

export const getRoUsersByBrokerId = async (brokerId: number) => {     // getApi to fetchUsers in the Usermaster screen
  try {
    const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
    const response = await axios.get(baseUrl + `api/user/getRoUsersByBrokerId?broker_id=${brokerId}`, {
      headers: {
        Authorization: `Bearer ${Token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status === 200) {
      return response?.data;
    }
  } catch (error) {
    console.error("Error in fetching the role:", error);
    throw error;
  }
};
// --------------------------------------------------------------------------------------------------------------------------------------//
